export default {
  name: 'pos_manage',
  path: 'pos_manage',
  component: () => import(/* webpackChunkName: "pos" */ './list.vue')
}
